import script from "./PlanosView.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanosView.vue?vue&type=script&setup=true&lang=js"

import "./PlanosView.vue?vue&type=style&index=0&id=2b114990&lang=css"

const __exports__ = script;

export default __exports__